import './_cost_accounting_calculator.js.coffee';

import './_cost_accounting_note_copier.js.coffee';

$(document).on('click', '.cancel[href="#"]', function(event) {
  return $(this).closest('form').get(0).reset();
});

$(document).on('turbo:load', function() {
  $('#person_manual_number').on('change', function(event) {
    return $('#person_number').prop('disabled', !this.checked);
  });
  $('form[data-readonly=true] input, ' + 'form[data-readonly=true] textarea, ' + 'form[data-readonly=true] select').attr('readonly', 'readonly');
  return $('form[data-readonly=true] input[type=checkbox], ' + 'form[data-readonly=true] input[type=radio]').attr('disabled', 'disabled');
});
